module.exports = __webpack_public_path__ + "static/img/szcy@2x.1660009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/szcy@2x.png
// module id = HYHu
// module chunks = 1